import { Button } from '@spritz-finance/ui'
import { useState } from 'react'
import { SET_UP_SMART_PAY } from '../../../../../../analytics/events'
import { Row } from '../../../../../../components/Layout/Row'
import { useAnalytics } from '../../../../../../context/useAnalytics'
import { AccountProvider, PayableAccountType } from '../../../../../../graphql/generated/graphql'
import { useWalletDialog } from '../../../../../../web3/connectDialog/WalletConnectDialogProvider'
import { useWeb3Connection } from '../../../../../../web3/Web3Provider'
import { SmartPayLogo } from '../SmartPayLogo'
import { CreateSubscriptionDialog } from './CreateSubscriptionDialog'

export type SubscriptionAccount = {
    id: string
    provider: AccountProvider
    logoUrl?: string | null
    name: string
    description?: string
    type: PayableAccountType
}

type CreateSubscriptionButton = {
    account: SubscriptionAccount
}

export const CreateSubscriptionButton: React.VFC<CreateSubscriptionButton> = ({ account }) => {
    const { connected } = useWeb3Connection()
    const { openWalletConnectDialog } = useWalletDialog()
    const [dialogOpen, setDialogOpen] = useState(false)
    const { trackAnalyticsEvent } = useAnalytics()

    const onClose = () => {
        setDialogOpen(false)
    }

    const onOpen = () => {
        trackAnalyticsEvent(SET_UP_SMART_PAY, { type: account.type, provider: account.provider })

        if (connected) {
            setDialogOpen(true)
        } else {
            openWalletConnectDialog(() => setDialogOpen(true))
        }
    }

    return (
        <>
            <Row>
                <SmartPayLogo onClick={onOpen} />
                <Button.Text style={{ fontSize: 14 }} onClick={onOpen}>
                    Set up recurring payment
                </Button.Text>
            </Row>
            <CreateSubscriptionDialog open={dialogOpen} onClose={onClose} account={account} />
        </>
    )
}
